import { createIcon } from '@chakra-ui/react'

const IconCheckCircle = createIcon({
  displayName: 'IconCheckCircle',
  viewBox: '0 0 16 16',
  path: (
    <path
      d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.54 6.29L7.29 10.54a.75.75 0 01-1.06 0L4.46 8.77a.75.75 0 111.06-1.06l1.3 1.3 3.72-3.72a.75.75 0 111.06 1.06z"
      fill="currentColor"
    />
  )
})

export default IconCheckCircle
